import React, { useEffect, useState } from 'react';
import { HeartIcon, SendIcon, StarIcon } from 'lucide-react';
interface Review {
  id: string;
  name: string;
  text: string;
  rating: number;
  likes: number;
  timeAgo: string;
}
const SEED_REVIEWS: Review[] = [{
  id: 's1',
  name: '@maria_mamapro',
  text: 'Aplicamos el pack desde la primera semana. Mis hijos ahora me piden cuándo es la próxima cita. Cambió totalmente la dinámica de casa. ❤️',
  rating: 5,
  likes: 47,
  timeAgo: 'hace 2 min'
}, {
  id: 's2',
  name: '@familia_lopez',
  text: 'Lo mejor son los espacios para pegar las fotos. Ya tenemos un álbum de recuerdos increíble después de 2 meses. Vale cada centavo.',
  rating: 5,
  likes: 38,
  timeAgo: 'hace 8 min'
}, {
  id: 's3',
  name: '@papa_de_mellis',
  text: 'Pensé que mis hijas adolescentes no iban a engancharse. Me equivoqué. Cada cita termina en charlas profundas. Recomendado al 100%.',
  rating: 5,
  likes: 92,
  timeAgo: 'hace 15 min'
}, {
  id: 's4',
  name: '@sofi_y_lucas',
  text: 'Mi marido y yo lo usamos como agenda de "tiempo de calidad". Antes pasaba el finde y no habíamos hecho nada. Ahora siempre tenemos plan.',
  rating: 5,
  likes: 56,
  timeAgo: 'hace 23 min'
}, {
  id: 's5',
  name: '@valentina.mama',
  text: 'El bono de "30 cosas que quiero que nunca olvides" me hizo llorar. Es el regalo más lindo que le puedo dejar a mi hija.',
  rating: 5,
  likes: 134,
  timeAgo: 'hace 31 min'
}, {
  id: 's6',
  name: '@diego_rg',
  text: 'Compré el pack completo y vale el doble lo que pagué. Las citas de pareja salvaron nuestro matrimonio post-pandemia. En serio.',
  rating: 5,
  likes: 78,
  timeAgo: 'hace 42 min'
}, {
  id: 's7',
  name: '@andrea_3hijos',
  text: 'Con tres hijos de edades distintas, tener ideas listas es oro. Cada uno elige su cita una vez por semana. Funciona increíble.',
  rating: 5,
  likes: 41,
  timeAgo: 'hace 1 h'
}, {
  id: 's8',
  name: '@carlitos.papa',
  text: 'Lo que más me gusta es que no requiere planificación. Llego cansado del laburo, abro el libro y listo. Mi hijo me espera.',
  rating: 5,
  likes: 29,
  timeAgo: 'hace 1 h'
}, {
  id: 's9',
  name: '@gabi_y_mati',
  text: 'Las preguntas para los abuelos fueron una bomba. Grabamos a mi mamá contando su historia y ahora es un tesoro familiar. 🥺',
  rating: 5,
  likes: 167,
  timeAgo: 'hace 2 h'
}, {
  id: 's10',
  name: '@pao.mama.de.dos',
  text: 'Lo recomiendo para regalar. Le regalé a mi hermana y ahora ella se lo regala a sus amigas. Es viral en mi círculo de mamás.',
  rating: 5,
  likes: 53,
  timeAgo: 'hace 3 h'
}, {
  id: 's11',
  name: '@familia_montoya',
  text: 'Hace 6 meses que lo usamos. Tengo el libro lleno de fotos pegadas y notas. Es un diario familiar invaluable.',
  rating: 5,
  likes: 84,
  timeAgo: 'hace 4 h'
}, {
  id: 's12',
  name: '@ramiro_papa',
  text: 'Vivo separado y tengo a mis hijos los finde. Esto me salvó. Tenemos rituales propios y los chicos esperan los sábados.',
  rating: 5,
  likes: 198,
  timeAgo: 'hace 5 h'
}];
const STORAGE_KEY = 'pack100citas_reviews_v1';
const LIKES_KEY = 'pack100citas_likes_v1';
export function CommunityReviewsSection() {
  const [reviews, setReviews] = useState<Review[]>(SEED_REVIEWS);
  const [likedIds, setLikedIds] = useState<Set<string>>(new Set());
  const [text, setText] = useState('');
  const [name, setName] = useState('');
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [submitted, setSubmitted] = useState(false);
  const [visibleCount, setVisibleCount] = useState(5);
  // Load saved state
  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved) {
        const parsed = JSON.parse(saved) as Review[];
        if (Array.isArray(parsed) && parsed.length > 0) {
          setReviews([...parsed, ...SEED_REVIEWS].slice(0, 15));
        }
      }
      const liked = localStorage.getItem(LIKES_KEY);
      if (liked) {
        setLikedIds(new Set(JSON.parse(liked) as string[]));
      }
    } catch {
      // ignore
    }
  }, []);
  const persistUserReviews = (userReviews: Review[]) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(userReviews));
    } catch {
      // ignore
    }
  };
  const persistLikes = (next: Set<string>) => {
    try {
      localStorage.setItem(LIKES_KEY, JSON.stringify(Array.from(next)));
    } catch {
      // ignore
    }
  };
  const handleLike = (id: string) => {
    setReviews(prev => prev.map(r => {
      if (r.id !== id) return r;
      const isLiked = likedIds.has(id);
      return {
        ...r,
        likes: r.likes + (isLiked ? -1 : 1)
      };
    }));
    setLikedIds(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);else next.add(id);
      persistLikes(next);
      return next;
    });
  };
  const handleSubmit = () => {
    if (!text.trim() || rating === 0) return;
    if (reviews.length >= 15) {
      setSubmitted(true);
      setTimeout(() => setSubmitted(false), 3000);
      return;
    }
    const newReview: Review = {
      id: `u${Date.now()}`,
      name: name.trim() || 'Familia anónima',
      text: text.trim(),
      rating,
      likes: 0,
      timeAgo: 'hace unos segundos'
    };
    const updated = [newReview, ...reviews].slice(0, 15);
    setReviews(updated);
    // Persist only the user-added ones (those with id starting with 'u')
    const userOnly = updated.filter(r => r.id.startsWith('u'));
    persistUserReviews(userOnly);
    setText('');
    setName('');
    setRating(0);
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 3000);
  };
  const canSubmit = text.trim().length > 0 && rating > 0 && reviews.length < 15;
  const visibleReviews = reviews.slice(0, visibleCount);
  const hasMore = visibleCount < reviews.length;
  return <section className="py-12 md:py-20 px-4 bg-black text-white" data-id="element-54">
      <div className="max-w-3xl mx-auto" data-id="element-55">
        <div className="text-center mb-8 md:mb-10" data-id="element-56">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-3 md:mb-4" data-id="element-57">
            ❤️ Opiniones de familias
          </h2>
          <p className="text-base md:text-lg text-gray-400 font-medium" data-id="element-58">
            Más de 800 familias ya están creando recuerdos con el Pack 100 Citas
          </p>
          <div className="flex items-center justify-center gap-2 mt-3" data-id="element-59">
            <div className="flex" data-id="element-60">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 md:w-6 md:h-6 fill-yellow-400 text-yellow-400" data-id="element-61" />)}
            </div>
            <span className="text-sm md:text-base text-gray-300 font-bold" data-id="element-62">
              4.9 / 5
            </span>
            <span className="text-xs md:text-sm text-gray-500" data-id="element-63">
              · {reviews.length} reseñas
            </span>
          </div>
        </div>

        {/* Review form */}
        <div className="bg-gray-900 border border-gray-800 rounded-2xl p-5 md:p-7 mb-6 md:mb-8 shadow-xl" data-id="element-64">
          <h3 className="text-base md:text-lg font-black text-white mb-4" data-id="element-65">
            Dejá tu reseña para la comunidad
          </h3>

          <textarea value={text} onChange={e => setText(e.target.value)} placeholder="Escribí tu experiencia con el Pack 100 Citas..." className="w-full bg-gray-950 border border-gray-700 rounded-xl p-3 md:p-4 text-sm md:text-base text-white placeholder-gray-500 mb-4 focus:outline-none focus:border-yellow-400 resize-none" rows={4} maxLength={400} data-id="element-66" />

          <div className="flex flex-col md:flex-row md:items-center gap-3 md:gap-4 mb-4" data-id="element-67">
            <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Tu nombre (opcional)" maxLength={40} className="flex-1 bg-gray-950 border border-gray-700 rounded-xl px-3 md:px-4 py-2.5 md:py-3 text-sm md:text-base text-white placeholder-gray-500 focus:outline-none focus:border-yellow-400" data-id="element-68" />

            <div className="flex items-center gap-2" data-id="element-69">
              <span className="text-sm md:text-base text-gray-400 font-medium" data-id="element-70">
                Calificá:
              </span>
              <div className="flex gap-1" data-id="element-71">
                {[1, 2, 3, 4, 5].map(star => <button key={star} type="button" onClick={() => setRating(star)} onMouseEnter={() => setHoverRating(star)} onMouseLeave={() => setHoverRating(0)} className="cursor-pointer transition-transform hover:scale-110" aria-label={`${star} estrellas`} data-id="element-72">
                    <StarIcon className={`w-6 h-6 md:w-7 md:h-7 transition-colors ${star <= (hoverRating || rating) ? 'fill-yellow-400 text-yellow-400' : 'fill-transparent text-gray-600'}`} data-id="element-73" />
                  </button>)}
              </div>
            </div>
          </div>

          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3" data-id="element-74">
            <button onClick={handleSubmit} disabled={!canSubmit} className={`inline-flex items-center justify-center gap-2 px-5 md:px-6 py-2.5 md:py-3 rounded-xl font-black text-sm md:text-base uppercase tracking-wide transition-all ${canSubmit ? 'bg-yellow-400 text-black hover:bg-yellow-300 cursor-pointer' : 'bg-gray-800 text-gray-500 cursor-not-allowed'}`} data-id="element-75">
              <SendIcon className="w-4 h-4 md:w-5 md:h-5" data-id="element-76" />
              PUBLICAR
            </button>

            {reviews.length >= 15 && <p className="text-xs md:text-sm text-yellow-400 font-medium" data-id="element-77">
                Límite de 15 reseñas alcanzado
              </p>}
          </div>

          {submitted && <p className="text-green-400 text-sm font-bold mt-3" data-id="element-78">
              ✅ ¡Gracias por compartir tu experiencia!
            </p>}
        </div>

        {/* Reviews list */}
        <div className="space-y-4" data-id="element-79">
          {visibleReviews.map(review => {
          const initial = review.name.replace('@', '').charAt(0).toUpperCase();
          const isLiked = likedIds.has(review.id);
          return <div key={review.id} className="bg-gray-900 border border-gray-800 rounded-2xl p-5 md:p-6" data-id="element-80">
                <div className="flex items-start justify-between mb-3 gap-3" data-id="element-81">
                  <div className="flex items-center gap-3 min-w-0 flex-1" data-id="element-82">
                    <div className="w-10 h-10 md:w-11 md:h-11 bg-yellow-400 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-83">
                      <span className="text-black font-black text-sm md:text-base" data-id="element-84">
                        {initial}
                      </span>
                    </div>
                    <div className="min-w-0 flex-1" data-id="element-85">
                      <p className="text-sm md:text-base font-bold text-white truncate" data-id="element-86">
                        {review.name}
                      </p>
                      <p className="text-[10px] md:text-xs text-gray-500" data-id="element-87">
                        {review.timeAgo}
                      </p>
                    </div>
                  </div>
                  <div className="flex flex-shrink-0" data-id="element-88">
                    {[...Array(5)].map((_, idx) => <StarIcon key={idx} className={`w-4 h-4 md:w-5 md:h-5 ${idx < review.rating ? 'fill-yellow-400 text-yellow-400' : 'fill-transparent text-gray-600'}`} data-id="element-89" />)}
                  </div>
                </div>
                <p className="text-sm md:text-base text-gray-300 font-medium leading-relaxed mb-4" data-id="element-90">
                  {review.text}
                </p>
                <div className="flex items-center" data-id="element-91">
                  <button onClick={() => handleLike(review.id)} className={`inline-flex items-center gap-2 text-sm font-bold transition-colors cursor-pointer ${isLiked ? 'text-pink-400' : 'text-gray-500 hover:text-pink-400'}`} aria-label={isLiked ? 'Quitar me gusta' : 'Me gusta'} data-id="element-92">
                    <HeartIcon className={`w-5 h-5 transition-all ${isLiked ? 'fill-pink-400 text-pink-400 scale-110' : 'fill-transparent'}`} data-id="element-93" />
                    <span data-id="element-94">{review.likes}</span>
                  </button>
                </div>
              </div>;
        })}
        </div>

        {hasMore && <div className="text-center mt-6 md:mt-8" data-id="element-95">
            <button onClick={() => setVisibleCount(c => Math.min(c + 5, reviews.length))} className="inline-flex items-center gap-2 px-5 md:px-6 py-2.5 md:py-3 rounded-xl border border-gray-700 bg-gray-900 hover:bg-gray-800 text-white font-bold text-sm md:text-base transition-colors cursor-pointer" data-id="element-96">
              Ver más reseñas ({reviews.length - visibleCount})
            </button>
          </div>}
      </div>
    </section>;
}